<template>
  <div class="visit-contact-redirect">
    <!-- Pantalla de carga global, mismo estilo que otras vistas -->
    <Loader v-if="loading" />

    <div v-else class="status-wrapper container">
      <div v-if="error" class="status error">
        <p>{{ error }}</p>
      </div>
      <div v-else class="status">
        <p>Redirigiendo al chat...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiUrls from "@/new-constants/apiUrls";
import Loader from "@/components/Ui/Loader.vue";

export default {
  name: "VisitContactRedirect",
  components: {
    Loader,
  },
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  computed: {
    accommodationId() {
      return this.$route.params.accommodationId;
    },
  },
  async created() {
    if (!this.accommodationId) {
      this.error = "Falta el identificador del alojamiento.";
      this.loading = false;
      return;
    }

    try {
      await axios.post(apiUrls.conversationsFromVisit, {
        accommodation_id: this.accommodationId,
      });
      // Una vez creada la conversación y enviado el mensaje automático,
      // redirigimos al listado de conversaciones.
      this.$router.replace({ name: "conversation" });
    } catch (e) {
      console.error("Error al crear la conversación desde la visita:", e);
      this.error =
        "Ocurrió un error al crear la conversación. Por favor, intenta de nuevo desde tu panel.";
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.visit-contact-redirect {
  position: relative;
  min-height: 60vh;
}

.status-wrapper {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status {
  text-align: center;
  font-size: 1rem;
}

.status.error {
  color: #c0392b;
}
</style>
